/** Derived company status (docs/PRODUCT.md § Statussen). The backend is the source of truth. */
export const STATUSES = ["kans", "tip", "gesprek", "volzet", "nee"] as const;

export type CompanyStatus = (typeof STATUSES)[number];

/** CSS custom properties per status, defined in tokens.css. */
export function statusTokens(status: CompanyStatus) {
  return {
    glyph: `var(--${status}-g)`,
    fg: `var(--${status}-fg)`,
    bg: `var(--${status}-bg)`,
  };
}
